





































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import GameDateTimePicker from '@/components/parts/GameDateTimePicker.vue';
import NotificationService from '@/services/notificationservice';

@Component({
  components: {
    GameDateTimePicker,
  },
})
export default class WarView extends Vue {
  @Prop() private diplomacy?: api.CountryWar;
  @Prop() private status!: def.CountryWarStatus;
  @Prop() private newData!: api.CountryWar;
  @Prop() private isSending!: boolean;
  @Prop() private canEdit!: boolean;
  @Prop() private isShow!: boolean;
  @Prop() private myCountryId!: number;
  @Prop() private targetCountryId!: number;
  @Prop() private system?: api.SystemData;
  private isPenalty: boolean = false;
  private isPenaltyIfStartWar: boolean = false;
  private isPenaltyIfStopWar: boolean = false;
  private isPenaltyTarget: boolean = false;
  private isPenaltyTargetIfStartWar: boolean = false;
  private isPenaltyTargetIfStopWar: boolean = false;
  private isUpdatingPenalty: boolean = false;

  @Watch('isShow')
  private onIsShowChanged() {
    if (this.isShow) {
      this.newData.status = -1;
      this.updateIsPenalty();
      this.updateIsPenaltyIfStartWar();
      this.updateIsPenaltyIfStopWar();
    }
  }

  private created() {
    this.onIsShowChanged();
  }

  private updateIsPenalty() {
    this.isUpdatingPenalty = true;
    api.Api.getWarPenaltyCountries(0, 0, api.CountryWar.statusStoped)
      .then((countries) => {
        this.isPenalty = countries.some((c) => c === this.myCountryId);
        this.isPenaltyTarget = countries.some((c) => c === this.targetCountryId);
      })
      .catch(() => {
        NotificationService.penaltyDataGetFalled.notify();
      })
      .finally(() => {
        this.isUpdatingPenalty = false;
      });
  }

  private updateIsPenaltyIfStartWar() {
    this.isUpdatingPenalty = true;
    api.Api.getWarPenaltyCountries(this.myCountryId, this.targetCountryId, api.CountryWar.statusAvailable)
      .then((countries) => {
        this.isPenaltyIfStartWar = countries.some((c) => c === this.myCountryId);
        this.isPenaltyTargetIfStartWar = countries.some((c) => c === this.targetCountryId);
      })
      .catch(() => {
        NotificationService.penaltyDataGetFalled.notify();
      })
      .finally(() => {
        this.isUpdatingPenalty = false;
      });
  }

  private updateIsPenaltyIfStopWar() {
    this.isUpdatingPenalty = true;
    api.Api.getWarPenaltyCountries(this.myCountryId, this.targetCountryId, api.CountryWar.statusStoped)
      .then((countries) => {
        this.isPenaltyIfStopWar = countries.some((c) => c === this.myCountryId);
        this.isPenaltyTargetIfStopWar = countries.some((c) => c === this.targetCountryId);
      })
      .catch(() => {
        NotificationService.penaltyDataGetFalled.notify();
      })
      .finally(() => {
        this.isUpdatingPenalty = false;
      });
  }
}
